import { TranslationsPage } from '@hendrx/core/translations';
import { redirect, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/translations')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAdmin) {
      throw redirect({
        to: '/login',
        search: { redirectTo: location.pathname }
      });
    }
  },
  component: TranslationsPage
});
